import { useRef, useState } from "react";
import Icon from "../../../a-atoms/icons/Icon";
import style from "./InputFile.module.css";

const InputFile = (props) => {
  const allowedExtensions = ["csv"];
  const [type, setType] = useState(props.type);
  const inputRef = useRef();
  const [error, setError] = useState("");
  const [file, setFile] = useState("");
  const [filename, setFilename] = useState("Choose CSV file");

  const handleFileChange = (e) => {
    setError("");

    // Check if user has entered the file
    if (e.target.files.length) {
      const inputFile = e.target.files[0];

      // Check the file extensions, if it not
      // included in the allowed extensions
      // we show the error
      const fileExtension = inputFile?.type.split("/")[1];
      if (!allowedExtensions.includes(fileExtension)) {
        setError("Please input a csv file");
        return;
      } else {
        var fileName = "";
        fileName = e.target.value.split("\\").pop();
        setFilename(fileName);
      }

      // If input type is correct set the state
      setFile(inputFile);
      props.onChange(inputFile);
    }
  };

  return (
    <div className={`${style.inputContainer} ${props.error && style.error}`}>
      <div className={style.container}>
      <label htmlFor="fileInput"><Icon>upload</Icon> {filename}</label>
        <input
          ref={inputRef}
          type="file"
          value={props.value}
          placeholder={props.placeholder}
          onChange={handleFileChange}
          id="fileInput"
        />
      </div>
      <div className={style.helper}>{props.error? props.error : props.helper}</div>
    </div>
  );
};

export default InputFile;
